import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import type {SustainabilityFactor} from '../models';

interface SustainabilityFactorCardProps {
  factor: SustainabilityFactor;
}

// Kaartje voor de duurzaamheidsfactoren.
// Laat zien waarom iets goed of slecht is (bijv. 'Geen Palmolie' of 'Vegan').
const SustainabilityFactorCard: React.FC<SustainabilityFactorCardProps> = ({factor}) => {
  return (
    <View style={stijlen.container}>
      <View style={stijlen.header}>
        <Text style={stijlen.icon}>{factor.icon}</Text>
        <Text style={stijlen.label}>{factor.label}</Text>
      </View>
      <Text style={stijlen.description}>{factor.description}</Text>
    </View>
  );
};

const stijlen = StyleSheet.create({
  container: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  icon: {
    fontSize: 24,
    marginRight: 12,
  },
  label: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  description: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
});

export default SustainabilityFactorCard;
